import React from 'react'
import { Menu } from '@headlessui/react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import {
  MenuItem as MenuItemStyle,
  ActiveItem,
  Button,
} from './style'
import Icon from '@components/Icon'

const MenuItem = (props) => {
  const { href, title, onClick, selected, target, dark = false, children } = props

  const getClasses = (active) =>
    classNames(
      MenuItemStyle,
      active ? ActiveItem : 'text-gray-700',
      href ? MenuItemStyle : Button,
      'text-black'
    )

  return (
    <Menu.Item>
      {({ active }) => (
        <>
          {href && (
            <a
              href={href}
              target={target}
              className={getClasses(active)}
            >
              {title}
              {selected && <Icon icon={'Check'} />}
            </a>
          )}
          {onClick && (
            <button
              onClick={onClick}
              type='button'
              className={getClasses(active)}
            >
              {title}
              {selected && <Icon icon={'Check'} />}
              {children}
            </button>
          )}
        </>
      )}
    </Menu.Item>
  )
}

MenuItem.propTypes = {
  href: PropTypes.string,
  title: PropTypes.string,
  target: PropTypes.string,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
}

export default MenuItem
